import { Intro } from '../../models';
import { useState } from 'react';
import ReactModal from 'react-modal';
import EditIntro from './EditIntro';
import { useTranslation } from 'react-i18next';

const emptyIntroFactory = (length: number): Intro => {
  return {
    title: '',
    introduction: '',
    imageUrl: '',
    imageDescription: '',
    step: length + 1,
  };
};

export default function IntroList({
  intros,
  ...callbacks
}: {
  intros: Intro[];
  onAdd: (intro: Intro) => void;
  onDelete: (index: number) => void;
  onUpdate: (index: number, intro: Intro) => void;
}) {
  const [t] = useTranslation('admin');
  const [isIntroModalOpen, setIsIntroModalOpen] = useState(false);
  const [index, setIndex] = useState<number | null>(null);

  const [introToEdit, setIntroToEdit] = useState<Intro>(
    emptyIntroFactory(intros.length)
  );

  const exitEditModal = () => {
    setIndex(null);
    setIntroToEdit(emptyIntroFactory(intros.length));
    setIsIntroModalOpen(false);
  };

  const onConfirm = (intro: Intro) => {
    if (index === null) {
      callbacks.onAdd(intro);
    } else {
      callbacks.onUpdate(index, intro);
    }
    exitEditModal();
  };

  const onEditClick = (i: number) => {
    setIndex(i);
    setIntroToEdit(intros[i]);
    setIsIntroModalOpen(true);
  };

  const onAddClick = () => {
    setIntroToEdit(emptyIntroFactory(intros.length));
    setIsIntroModalOpen(true);
  };

  const onDeleteClick = (i: number) => {
    callbacks.onDelete(i);
  };

  return (
    <>
      <div className="flex flex-col gap-2 mb-4">
        <label className="font-medium text-[#53586C]">
          {t('activity_intro_preview', '互動內容預覽')}
        </label>
        {intros.map((intro, index) => {
          return (
            <div key={index} className="flex gap-2">
              <span className="w-[300px] max-w-[300px] overflow-ellipsis overflow-hidden whitespace-nowrap">
                {intro.title}
              </span>
              <button
                className="flex flex-shrink items-center text-group-primary font-medium"
                type="button"
                onClick={() => onEditClick(index)}
              >
                <span className="material-symbols-outlined">edit</span>
              </button>
              <button
                className="flex flex-shrink items-center text-group-primary font-medium"
                type="button"
                onClick={() => onDeleteClick(index)}
              >
                <span className="material-symbols-outlined">delete</span>
              </button>
            </div>
          );
        })}
        <button
          type="button"
          className="cursor-pointer text-group-primary border border-group-primary rounded flex justify-center items-center text-sm px-6 font-normal h-[48px] w-fit mt-2"
          onClick={onAddClick}
        >
          {t('add_activity_intro_preview', '新增預覽')}
        </button>
      </div>

      <ReactModal
        isOpen={isIntroModalOpen}
        overlayClassName="z-[51] fixed bg-black/[.4] inset-0 backdrop-blur-sm"
        className="flex h-full w-full justify-center items-center px-5"
      >
        <EditIntro
          intro={introToEdit}
          onCancel={exitEditModal}
          onConfirm={onConfirm}
        />
      </ReactModal>
    </>
  );
}
